import { FC, PropsWithChildren } from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ruRU } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import 'dayjs/locale/ru';

import { LOCALES } from '@/shared/constants';

dayjs.locale(LOCALES.ru);
dayjs.extend(duration);

/**
 * Русские подписи пикеров (19061): `adapterLocale` переводит только форматы дат
 * (месяцы, дни недели), а служебные тексты — кнопка календаря «Choose date, selected
 * date is…», «Open previous view» и т. п. — без `localeText` оставались английскими,
 * и скринридер читал их по-английски на русском интерфейсе.
 */
const PICKERS_LOCALE_TEXT =
  ruRU.components.MuiLocalizationProvider.defaultProps.localeText;

/**
 * Провайдер для локализации и даты
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const LocalizationAndDate: FC<PropsWithChildren> = ({ children }) => {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={LOCALES.ru}
      localeText={PICKERS_LOCALE_TEXT}
    >
      {children}
    </LocalizationProvider>
  );
};
